<template>
  <div class="mfa-step">
    <div class="mfa-step_header">
      <div>
        <img :src="googleAuth" width="64" alt="Google Auth" />
      </div>
      <h2>Escanea el QR con Google Authenticator</h2>
      <p>
        En la aplicación, presiona el botón "+", ubicado en la esquina inferior <br/>
        derecha, y selecciona “Escanear un código QR”. 
      </p>
    </div>
    <div class="mfa-qr">
      <div v-if="!loadingQr">
        <img :src="qrUrl" alt="QR code" />
      </div>
      <div v-else class="mfa-qr_loading">
        <LoadingOutlined :style="{ fontSize: '40px' }" />
      </div>
    </div>
    <div class="mfa-step_footer">
      <p>
        Una vez escaneado con éxito, puedes continuar:
      </p>
      <a-button type="primary" @click="$emit('next')">Continuar</a-button>
      <a-button @click="$emit('back')">Regresar</a-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import googleAuth from "@/app/auth/assets/google_auth.png?url";
import { mfaService } from "@/app/auth/services/MfaService";
import { MfaType } from '../../utils/enums';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { ResponseError } from '@/app/shared/utils/httpManager';
import { message } from 'ant-design-vue';

const qrUrl = ref("");
const loadingQr = ref(false);

onMounted(async () => {
  loadingQr.value = true;
  const storedData = window.atob(sessionStorage.getItem("authenticationData") || '');
  const userData = JSON.parse(storedData);
  try {
    const response = await mfaService.generateToken({
      username: userData?.username,
      password: userData?.password,
      mfa_type: MfaType.Google,
    });
    qrUrl.value = response?.qr_code;
    loadingQr.value = false;
  } catch (error) {
    const messageError =
      error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

    message.error(messageError);
  }
});
</script>

<style scoped lang="sass">
.mfa-step
  text-align: center
  flex-direction: column
  display: flex
  gap: 24px
  justify-content: center
  justify-items: center
  align-items: center
  &_header
    display: flex
    flex-direction: column
    gap: 16px
    text-align: center
  h2
    font-weight: 600
    margin-bottom: 0
    font-size: 24px
    line-height: 32px
  p
    margin: 0
    color: #000000A6
    font-size: 14px
  &_footer
    width: 420px
    display: flex
    flex-direction: column
    gap: 16px
    text-align: center

  .mfa-stores
    display: flex
    justify-content: center
    gap: 1rem

    img
      height: 40px

  .mfa-qr
    img
      width: 168px
      // padding: 12px
      border-radius: 8px
      border: 1px solid #0000000F
    &_loading
      display: flex
      justify-content: center
      align-items: center
      height: 168px
      width: 168px
      border-radius: 8px
      border: 1px solid #0000000F
      background-color: #F5F5F5

  .mfa-help
    margin-top: 8px
    font-size: 14px
    color: #000000A6
    display: flex
    gap: 8px
    align-items: center
    a
      display: flex
      gap: 6px
      align-items: center
</style>